import { styled } from '@pulse-web-ui/theme';

export const AgentContractAgreementsWrapper = styled.div`
  width: 100%;
`;
